import React, { Component } from 'react';
import PriceForm from './PriceForm';

class App extends Component {
  render() {
    return (
      <div className="App">
      <PriceForm />
      </div>
    );
  }
}

export default App;
